import { CustomModalCell } from '../../components/custom-modal-cell';
import { CustomCarCell } from './components/custom-car-cell';

export const FORM_NAME = 'cars-form';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const CAR_TABLE_COLUMNS_NAMES = [
	{ id: 'title' },
	{ id: 'value', customComponent: CustomModalCell },
	{ id: 'mode', customComponent: CustomCarCell },
];

export const CAR_TABLE_ROWS_NAMES = {
	company: 'Компания',
	legal: 'Юр. лицо',
	number: 'Гос. номер',
	vin: 'Vin номер',
	type: 'Тип машины',
	dateIssue: 'Год выпуска машины',
	typeDateIssue: 'Год выпуска рефрижератора',
	weight: 'Грузоподъемность',
	volume: 'Вместимость',
	ownership: 'Тип владения',
	docName: 'Название документа',
	docNumber: 'Номер документа',
	docDate: 'Дата выдачи документа',
	trailer: 'Прицеп по умолчанию',
	isAccredited: 'Машина аккредитована',
	author: 'Автор',
};

export const FIELDS_FOR_VALIDATE = [
	'legal_id',
	'name',
	'number',
	'type_id',
	'date_issue',
	'weight',
	'volume',
	'ownership_id',
];

export const FORM_FIELDS = [
	'legal_id',
	'name',
	'number',
	'vin',
	'type_id',
	'date_issue',
	'type_date_issue',
	'weight',
	'volume',
	'ownership_id',
	'doc_name',
	'doc_number',
	'doc_date',
	'trailer_id',
	'modes',
];

export const TYPES_WITH_DATE_ISSUE_AND_MODES = ['2'];

export const TYPES_WITH_TRAILER = ['1'];

export const TYPES_WITHOUT_OWNERSHIP_INFO = [1, 2];
